import React, {Component} from 'react';
import Teaser from '../common/Teaser/Teaser';
import Video from '../common/Video/Video';
import CustomSelect from '../common/CustomSelect';
import Filters from './Filters/Filters';
import * as settings from "./settings";
import axios from 'axios';

export default class PostFeed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            page: 1,
            posts: [],
            filters: [],
            sortingType: Object.keys(settings.sortingOptions)[0],
            morePostsAvailable: false,
            categoryId: this.props.categoryId ? this.props.categoryId : '',
            categoryParentId: this.props.parentCategoryId ? this.props.parentCategoryId : '',
            showInfo: false,
        };

        this.callAPI = this.callAPI.bind(this);

        // Event handlers
        this.updateParametersWithActiveFilters = this.updateParametersWithActiveFilters.bind(this);
        this.onSortingTypeChange = this.onSortingTypeChange.bind(this);
        this.onLoadMoreClick = this.onLoadMoreClick.bind(this);

        // Search query modifications
        this.getSearchQuery = this.getSearchQuery.bind(this);
        this.updateQueryString = this.updateQueryString.bind(this);
    }

    componentDidMount() {
        if(this.props.showFilters) {
            this.callAPI(settings.feedAPIurls.filters, {}, 'filters');
        } else {
            // Component shown on the product page
            let url = this.state.categoryId ? settings.feedAPIurls.postsInCategory : settings.feedAPIurls.posts;
            this.callAPI(url, {
                sortingType: settings.sortingOptions[this.state.sortingType],
                numberOfStartingPost: 0,
                numberOfPosts: settings.postCount.noFilters,
                categoryId: this.state.categoryId,
                categoryParentId: this.state.categoryParentId
            }, 'posts');
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.sortingType != this.state.sortingType ||
           prevState.categoryId != this.state.categoryId ||
           prevState.page != this.state.page) {
            let url = this.state.categoryId ? settings.feedAPIurls.postsInCategory : settings.feedAPIurls.posts;
            this.callAPI(url, {
                sortingType: settings.sortingOptions[this.state.sortingType],
                numberOfStartingPost: 0,
                numberOfPosts: settings.postCount.starting + (this.state.page - 1) * settings.postCount.delta,
                categoryId: this.state.categoryId,
                categoryParentId: this.state.categoryParentId
            }, 'posts');

            this.updateQueryString();
        }
    }

    updateQueryString() {
        let search = new URL(window.location);
        search.searchParams.set('order', this.state.sortingType);

        if(this.state.categoryId) {
            search.searchParams.set('category', this.state.categoryId)
        } else {
            search.searchParams.delete('category');
        }

        if(this.state.page > 1) {
            search.searchParams.set('page', this.state.page)
        } else {
            search.searchParams.delete('page');
        }

        history.pushState({}, '', search);
    }

    getSearchQuery() {
        var reg = /^\d+$/;

        let search = window.location.search;
        let params = new URLSearchParams(search);

        let page = params.get('page');
        if(!reg.test(page) || page < 1) {
            page = 1;
        }

        let order = params.get('order');
        if(!Object.keys(settings.sortingOptions).includes(order)) {
            order = null;
        }

        let category = params.get('category');
        let match = null;
        if(reg.test(category)) {
            this.state.filters.forEach(filter => {
                if(filter.Id == category) {
                    match = filter;
                    return;
                }
                filter.Subcategory.forEach(subcategory => {
                    if(subcategory.Id == category) {
                        match = subcategory;
                        return;
                    }
                })
            });
        } else {
            category = '';
        }

        let categoryId = match ? match.Id : '';
        let categoryParentId = match ? match.ParentId: '';
        let url = match ? settings.feedAPIurls.postsInCategory : settings.feedAPIurls.posts;

        this.callAPI(url, {
            sortingType: order ? settings.sortingOptions[order] : settings.sortingOptions[this.state.sortingType],
            numberOfStartingPost: 0,
            numberOfPosts: page ? settings.postCount.starting + (page - 1) * settings.postCount.delta : settings.postCount.starting,
            categoryId: categoryId,
            categoryParentId: categoryParentId,
        }, 'posts');

        this.setState({
            page: page,
            sortingType: order ? order : Object.keys(settings.sortingOptions)[0],
            categoryId: categoryId,
            categoryParentId: categoryParentId,
        })
    }

    callAPI(url, params, type) {
        this.setState({
            isLoading: true
        });

        axios
        .get(url, {
            params: params,
        })
        .then(response => {
            if(response.data) {
                switch(type) {
                    case 'posts':
                        this.setState({
                            isLoading: false,
                            posts: response.data.Articles,
                            morePostsAvailable: response.data.MoreArticlesAvailable,
                            showInfo: response.data.Articles.length < 1
                        });
                        break;
                    case 'filters':
                        this.setState({
                            isLoading: false,
                            filters: response.data
                        });
                        this.getSearchQuery()
                        break;
                    case 'button':
                        this.setState(prevState => ({
                            isLoading: false,
                            posts: [...prevState.posts, ...response.data.Articles],
                            morePostsAvailable: response.data.MoreArticlesAvailable,
                        }));
                        break;
                    default: return;
                }
            };
        });
    }

    updateParametersWithActiveFilters(categoryId, categoryParentId) {
        this.setState({
            page: 1,
            categoryId: categoryId,
            categoryParentId: categoryParentId
        });
    }

    onSortingTypeChange(value) {
        this.setState({
            page: 1,
            sortingType: value
        });
    }

    onLoadMoreClick() {
        let url = this.state.categoryId ? settings.feedAPIurls.postsInCategory : settings.feedAPIurls.posts;
        this.callAPI(url, {
            sortingType: settings.sortingOptions[this.state.sortingType],
            numberOfStartingPost: this.state.posts.length,
            numberOfPosts: settings.postCount.delta,
            categoryId: this.state.categoryId,
            categoryParentId: this.state.categoryParentId
        }, 'button');
        this.setState({
            page: this.state.page + 1
        });
    }

    render() {
        let posts = this.state.posts.map((post, index) => {
            if(post.VideoEmbed || post.VideoUrl) {
                return <div className="flowList__item" key={'post-' + index}>
                    <div className="single-teaser">
                        <Video embedCode={post.VideoEmbed}
                               localVideoUrl={post.VideoUrl}
                               imageUrl={post.ImageUrl} />
                        <div class="flowList__item-content single-teaser-content">
                            <h4 className="heading heading--quaternary single-teaser-growing-header">
                                <a href={post.Url}>
                                    {post.Title}
                                </a>
                            </h4>
                            <div className="preview-intro">
                                {post.PostIntro}
                            </div>
                        </div>
                    </div>
                </div>
            } else {
                return <div className="flowList__item" key={'post-' + index}>
                    <Teaser teaserUrl={post.Url}
                            teaserText={post.Title}
                            teaserDetails={post.PostIntro}
                            imageUrl={post.ImageUrl}
                            imageAlt={post.ImageAlt}
                            imageTitle={post.ImageAlt} />
                </div>
            }
        });

        let filters = this.props.showFilters ?
            <Filters filters={this.state.filters} activeFilter={this.state.categoryId} activeFilterCallback={this.updateParametersWithActiveFilters}/>
        : null;

        let sorting = this.props.showFilters ?
            <div className="post-feed__sorting">
                <span><strong>Sort articles:</strong> from the </span>
                <CustomSelect
                    labelId=''
                    optionsListName=""
                    selectedOption={this.state.sortingType}
                    key={this.state.sortingType}
                    options={Object.keys(settings.sortingOptions)}
                    onValueSelection={this.onSortingTypeChange}
                />
            </div>
        : null;

        let loadMoreButton = this.props.showFilters && this.state.morePostsAvailable ?
            <button type="button"
                    className="btn--wide btn--primary post-feed__load-more"
                    title="Load more posts"
                    disabled={this.state.isLoading}
                    onClick={this.onLoadMoreClick}>
                Load more
            </button>
        : null;

        return (
            <div className="post-feed clearfix">
                <div className={this.props.showFilters ? "column primary" : ""}>
                    {sorting}
                    <div className={this.props.showFilters ? "flowList few" : "flowList single"}>
                        {posts}
                        {this.state.showInfo ? <div className="post-feed__info">Sorry, there are no posts matching your search criteria.</div> : null}
                    </div>
                    <div className="loader--full-screen" hidden={!this.state.isLoading}>
                        <div className="loader__icon"/>
                    </div>
                    {loadMoreButton}
                </div>
                {filters}
            </div>
        );
    }
}
